import { render } from "./Category.vue?vue&type=template&id=9fe05406&scoped=true"
import script from "./Category.vue?vue&type=script&lang=js"
export * from "./Category.vue?vue&type=script&lang=js"

import "./Category.vue?vue&type=style&index=0&id=9fe05406&scoped=true&lang=css"
import "./Category.vue?vue&type=style&index=1&id=9fe05406&scoped=true&lang=css"

import exportComponent from "F:\\App-themes\\clickon\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fe05406"]])

export default __exports__